module.exports = __webpack_public_path__ + "img/bonDeCommande.89066502.png";